import styled from "@emotion/styled";
import { Button } from "src/atoms/Button";
import { ChevronLeft } from "src/icons/ChevronLeft";

const Wrapper = styled.div`
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  transform: translateX(100%);
  transition: transform 0.2s ease-in-out;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndex.drawer};

  &.Drawer_open {
    transform: translateX(0);
  }
`;

const Content = styled.div`
  background-color: ${({ theme }) => theme.colors.tone.white};
  height: 100%;
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;
`;

const ArrowLeft = styled(ChevronLeft)`
  margin-left: ${({ theme }) => theme.space[3]}px;
  margin-right: ${({ theme }) => theme.space[3]}px;
  width: 12px;
`;

const DrawerButton = styled(Button)`
  background-color: transparent;
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  line-height: 1.5;
  letter-spacing: 0.4px;
  padding: ${({ theme }) => theme.space[0]} ${({ theme }) => theme.space[3]}px;
`;

export { Wrapper, Content, DrawerButton, ArrowLeft };
